<template>
  <loader-wrapper :loading="isLoadingDay">
    <section id="bid-day">
      <el-row :gutter="24" type="flex" align="middle">
        <el-col class="sh-checkbox" :span="1">
          <el-checkbox :label="day.id" :value="day.id" />
        </el-col>

        <day-date :day="day" />

        <el-col :span="1" class="ta-c">
          <b>{{ day.cars_count }}</b>
        </el-col>

        <day-count :day="day" />

        <el-col :span="2" class="flex-col">
          <img src="@/assets/img/black_truck.svg" alt="" />
          {{ getShortage(day) }}
        </el-col>

        <doc-count :loading="docLoading" :info="docInfo" />

        <day-prices :day="day" />

        <day-buttons
          :bid-id="bidId"
          :day="day"
          @close="onClose"
          v-on="$listeners"
        />
      </el-row>
    </section>
  </loader-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import DayButtons from './components/DayButtons'
import DayCount from './components/DayCount'
import DayDate from './components/DayDate'
import DayPrices from './components/DayPrices'
import DocCount from './components/DocCount'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'BidDay',
  components: {
    LoaderWrapper,
    DayDate,
    DayPrices,
    DocCount,
    DayCount,
    DayButtons,
  },
  props: {
    bidId: {
      type: Number,
      default: 0,
    },
    day: {
      type: Object,
      default: () => {},
    },
    docInfo: {
      type: Object,
      default: () => {},
    },
    docLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('bids', ['getLoading']),
    isLoadingDay() {
      return this.getLoading('Day')
    },
  },
  methods: {
    onClose() {
      this.$emit('close-day', this.day)
    },
    getShortage(b) {
      if (!b.responses_count_total && !Number(b.response_requests_count)) {
        return b.cars_count
      }
      const res =
        b.cars_count -
        b.responses_count_total -
        Number(b.response_requests_count)

      return res > 0 ? res : 0
    },
  },
}
</script>

<style lang="sass">
#bid-day
  position: relative
  border-radius: 2px
  padding: 20px
  background: #F4F4F4
  border: 1px solid #CBCBCB
  box-sizing: border-box
  font-size: 16px
  margin: 15px 0
  color: #000
  .flex-col
    display: flex
    align-items: center
    justify-content: center
    img
      margin-right: 10px
  .sh-checkbox
    .el-checkbox__label
      display: none
  .rt-dayInfo
    margin:  12px 0
    line-height: 0
    color: #aaa8ab
    font-weight: normal
    font-size: 12px
    justify-content: normal
  .rt_price
    display: flex
    justify-content: center
    font-size: 16px
    line-height: 21px
    color: #98A9BC
    font-weight: normal
  .more_info
    font-weight: normal
    color: #409EFF
    &:hover
      cursor: pointer
      text-decoration: underline
</style>
